import { common } from '@material-ui/core/colors';
import { createTheme, alpha } from '@material-ui/core/styles';
import transitions from '@material-ui/core/styles/transitions';

const theme = createTheme({
  typography: {
    fontFamily: [
      'Lato',
      'sans-serif',
    ].join(','),
  },
  palette: {

  },
  props: {
    MuiInput: {
      disableUnderline: true,
    },
    MuiInputLabel: {
      shrink: true,
    },
    MuiFormControl: {
      fullWidth: true,
    },
    MuiTextField: {
      fullWidth: true,
    },
    MuiAppBar: {
      position: 'fixed',
      color: 'default'
    }
  },
  overrides: {
    MuiInputLabel: {
      root: {
        minWidth: 200,
        '&.$Mui-error': {
          color:'#617385'
        }
      },
      shrink: {
        transform: 'translate(0, -4.5px) scale(1)'
      }
    },
    MuiInput: {
      root: {
        'label + &': {
          marginTop: 10,
        },
      },
      inputMultiline: {
        padding: '10px 12px'
      },
    },
    MuiInputBase: {
      root: {
        'label + &': {
          marginTop: 10,
        },
      },
      multiline:{
        padding:0
      },
      inputMultiline: {
        root: {
          padding: 0
        }
      },
      input: {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: common.white,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 12px',
        transition: transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
          'Lato',
          'sans-serif',
        ].join(','),
        '&:focus': {
          boxShadow: `${alpha('#044ada', 0.25)} 0 0 0 0.2rem`,
          borderColor: '#044ada',
        },
        '&.$Mui-error': {
          boxShadow: `${alpha('#da172e', 0.25)} 0 0 0 0.2rem`,
          border: '1px solid #da3330',
        },
        '&:not([aria-invalid=false])': {
          border: '1px solid #B22400',
          '&:focus': {
            boxShadow: `${alpha('#da172e', 0.25)} 0 0 0 0.2rem`,
          }
        },
        "&::placeholder": {
          fontSize: 14,
          fontFamily: 'Lato'
        }
      },
      '&.$Mui-error ': {
        input: {
          borderColor: 'red'
        }
      }
    },
    MuiSelect: {
      root: {
        'label + &': {
          marginTop: 10,
        },
        "&.$Mui-disabled": {
          backgroundColor: '#fafafa'
        }
      },
      select: {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: common.white,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 12px',
        transition: transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
          'Lato',
          'sans-serif',
        ].join(','),
        '&:focus': {
          boxShadow: `${alpha('#044ada', 0.25)} 0 0 0 0.2rem`,
          borderColor: '#044ada',
        },
        '&.Mui-error': {
          boxShadow: `${alpha('#da172e', 0.25)} 0 0 0 0.2rem`,
          borderColor: '#da3330',
        },
        '&:not([aria-invalid=false])': {
          border: '1px solid #DB340B',
          '&:focus': {
            boxShadow: `${alpha('#da172e', 0.25)} 0 0 0 0.2rem`,
          }
        },
      },
      input: {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: common.white,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 12px',
        transition: transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
          'Lato',
          'sans-serif',
        ].join(','),
        '&:focus': {
          boxShadow: `${alpha('#044ada', 0.25)} 0 0 0 0.2rem`,
          borderColor: '#044ada',
        },
        '&.Mui-error': {
          boxShadow: `${alpha('#da172e', 0.25)} 0 0 0 0.2rem`,
          borderColor: '#da3330',
        },
        "&$error": {
          boxShadow: `${alpha('#da172e', 0.25)} 0 0 0 0.2rem`,
          borderColor: '#da3330',
        }
      },
    },
    MuiAppBar: {
      root: {
        height: 60,
        boxShadow: 'none',
        borderBottom: '1px solid #dad4dd'
      },
      colorDefault: {
        backgroundColor: '#fff'
      },
      colorPrimary: {
        backgroundColor: '#005EB8',
        boxShadow: 'none',
      }
    },
    MuiFormHelperText: {
      root: {
        fontStyle: 'italic',
        color: '#B22400!important',
      }
    },
    MuiButton: {
      root: {
        border: 6,
        boxSizing: 'border-box',
        position: 'relative',
      },
      label: {
        textTransform: 'none',
        fontSize: 14,
      },
      text: {
        color: '#005EB8',
        '&:hover:not($disabled):not(:focus)': {
          backgroundColor: '#005EB8',
          color: '#fff',
        },
        '&:focus': {
          backgroundColor: '#005EB8',
          color: '#fff',
          boxShadow: `${alpha('#c2c4d1', 0.25)} 0 0 0 3px`,
        },
        '&$disabled': {
          color: '#6892e8'
        }
      },
      colorInherit: {
        backgroundColor: '#fff',
        color: "#005EB8",
        boxShadow: 'none',
        '&:hover:not($disabled):not(:focus)': {
          backgroundColor: '#edf4ff',
          boxShadow: 'none',
          border: 'solid 1px #97c1ff',
        },
        '&:focus': {
          backgroundColor: '#fff',
          color: "#044ada",
          border: 'solid 3px #c9ddff',
        },
        '&:active': {
          boxShadow: 'none',
        },
      },
      contained: {
        backgroundColor: '#005EB8',
        color: "#fff",
        boxShadow: 'none',
        borderRadius: '4px',
        '&:hover:not($disabled):not(:focus)': {
          backgroundColor: '#0430ad',
          boxShadow: 'none',
        },
        '&:focus': {
          backgroundColor: '#005EB8',
          color: '#fff',
          border: 'solid 3px #c2c4d1',
        },
        '&:active': {
          boxShadow: 'none',
        },
      },
      containedPrimary: {
        backgroundColor: '#56d679',
        color: "#02032a",
        boxShadow: 'none',
        '&:hover:not($disabled):not(:focus)': {
          backgroundColor: '#1a8038',
          boxShadow: 'none',
          color: "#fff"
        },
        '&:focus': {
          backgroundColor: '#56d679',
          color: '#fff',
        },
        '&:active': {
          boxShadow: 'none',
        },
      },
      containedSecondary: {
        backgroundColor: '#e71d32',
        color: "#fff",
        boxShadow: 'none',
        '&:hover:not($disabled):not(:focus)': {
          backgroundColor: '#ad1624',
          boxShadow: 'none',
        },
        '&:focus': {
          border: 'solid 3px #ffa5b4',
          backgroundColor: '#e71d32',
        },
      },
      outlined: {
        color: '#005EB8',
        backgroundColor: '#fff',
        border: '1px solid #005EB8',
        '&:hover:not($disabled):not(:focus)': {
          backgroundColor: '#edf4ff',
        },
        '&:focus': {
          backgroundColor: '#fff',
          boxShadow: `${alpha('#c9ddff', 0.25)} 0 0 0 3px`,
        },
      }
    },
  },
});

export default theme;
